window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.AjaxPagination = (function AjaxPagination() {

    'use strict';

    /**
     * jQuery elements
     * @private
     */

    /**
     * Has the class been initialized?
     * @private
     */
    let inited = false;

    /**
     * Initializes the class.
     * @public
     */
    const init = function () {

        // Abort if already initialized
        if (inited) {
            return false;
        }

        inited = true;

        const $paginations = document.querySelectorAll('[data-ajax-pagination]');

        $paginations.forEach(function($paginationEl) {
          $paginationEl.addEventListener('click', function(e){
            e.preventDefault();

            if (!e.target.matches('a') && !e.target.matches('span')) { return }

            let $page = e.target.matches('span') ? e.target.parentNode : e.target;
            if (!$page) { return }

            const $pagination = $page.parentNode.parentNode;
            const zone = $pagination.dataset.ajaxPagination;
            const $ajaxZone = document.querySelector('[data-ajax-paginate="' + zone + '"]');
            const apiURL = $page.getAttribute('href');

            // Show loader
            const loaderHtml = '<div class="loader-container" style="height: ' + $ajaxZone.clientHeight + 'px;"><div class="loader"><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div></div>';
            $ajaxZone.innerHTML = loaderHtml;

            fetch(apiURL, {
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
              method: 'GET'
            })
            .then((resp) => resp.text())
            .then(function(data) {
              if (data) {
                const htmlResponse = document.createElement('div');
                htmlResponse.innerHTML = data;

                const selector = '[data-ajax-paginate="' + $pagination.getAttribute('data-ajax-pagination') + '"]';
                const paginationSelector = '[data-ajax-pagination="' + $pagination.getAttribute('data-ajax-pagination') + '"]';

                $ajaxZone.innerHTML = htmlResponse.querySelector(selector).innerHTML;
                $pagination.innerHTML = htmlResponse.querySelector(paginationSelector).innerHTML;
              }
            });
          });
        });

        return true;

    };

    // Expose public methods & properties
    return {
        init: init,
    };

}());
